export const fnbPermissions = {
  readOrder: 'read:fnb-order',
  readRefund: 'read:fnb-refund',
};
